// extracted by mini-css-extract-plugin
module.exports = {"Small":"style_Small__XTva7","Medium":"style_Medium__3_YdT","Large":"style_Large__EWe6K"};